import { assertPackageVersion } from '@dynamic-labs-sdk/assert-package-version';

import { name, version } from '../../package.json';

assertPackageVersion(name, version);

export { createWalletConnectSessionEventEmitter } from '../createWalletConnectSessionEventEmitter';
export { SessionClosedUnexpectedlyError } from '../errors/SessionClosedUnexpectedlyError';
export { importWalletConnectAuthResponse } from '../importWalletConnectAuthResponse';
export { importWalletConnectSession } from '../importWalletConnectSession';
export { getSignClient } from '../signClient/getSignClient';
export { splitCaip10Token } from '../splitCaip10Token';
export type { WalletProviderBuilder } from '../walletConnectWalletProvider.types';
